<script setup lang="ts">
import { ref } from 'vue'

import { PurchaseOptions } from '@toni/commerce-api-types'
import { classMerge } from '@toni/brand-ui'

import PurchaseOption from './PurchaseOption.vue'
import { BUTTON_TYPE } from '../utils/types'

withDefaults(defineProps<{
  alternativePurchaseOptions: PurchaseOptions,
  isComparison?: boolean
  type?: BUTTON_TYPE.icon | BUTTON_TYPE.regular
}>(),
{
  isComparison: false,
  type: BUTTON_TYPE.regular
}
)
const isExpanded = ref(false)
const toggleExpand = (): boolean => (isExpanded.value = !isExpanded.value)
</script>

<template>
  <div v-if="alternativePurchaseOptions.length > 0"
       class="flex flex-col gap-2.5 w-full">
    <a
      v-if="!isExpanded && !isComparison"
      href="#"
      class="text-action underline whitespace-nowrap text-xs"
      @click.prevent="toggleExpand">
      {{ $t('commerce.alternativeVendorsNoPrice', {count: alternativePurchaseOptions?.length}) }}
    </a>
    <div :class="classMerge(
      'flex-col justify-between mt-2.5 gap-2.5 w-full',
      isExpanded || isComparison ? 'flex animate-in fade-in duration-500' : 'hidden'
    )">
      <PurchaseOption v-for="alternate in alternativePurchaseOptions"
                      :key="alternate.merchant.name || ''"
                      size="md"
                      :purchase-option="alternate"
                      :is-comparison="isComparison"
                      :type="type" />
    </div>
  </div>
</template>
